"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _head = _interopRequireDefault(require("@/components/head"));
var _dayReport = _interopRequireDefault(require("./components/dayReport"));
var _monthReport = _interopRequireDefault(require("./components/monthReport"));
var _yearReport = _interopRequireDefault(require("./components/yearReport"));
var _runType = _interopRequireDefault(require("./components/runType.vue"));
var _diagnosis = _interopRequireDefault(require("./components/diagnosis.vue"));
var _diagnosisHistory = _interopRequireDefault(require("./components/diagnosisHistory.vue"));
var _alarm = _interopRequireDefault(require("./components/alarm.vue"));
var _energy = _interopRequireDefault(require("./components/energy.vue"));
var _default = exports.default = {
  components: {
    headr: _head.default,
    day: _dayReport.default,
    month: _monthReport.default,
    year: _yearReport.default,
    runType: _runType.default,
    diagnosis: _diagnosis.default,
    diagnosisHistory: _diagnosisHistory.default,
    alarm: _alarm.default,
    energy: _energy.default
  },
  data: function data() {
    return {
      activeName: "",
      yuming: "http://toncentsoft.eatuo.com:8091/energyExcel/益田假日广场历史数据报表1608863633345.xlsx",
      // 域名  管理方便一点  /m 域名下的文件夹
      viewVisible: false,
      // 弹框隐藏
      fileType: "pdf",
      // 文件类型
      pdfsrc: "",
      // 文件地址
      type: 1,
      menusList: []
    };
  },
  computed: {},
  destroyed: function destroyed() {
    sessionStorage.removeItem("firstInit");
  },
  created: function created() {
    // 初始化重置样式
    if (!sessionStorage.getItem("firstInit")) {
      sessionStorage.setItem("firstInit", true);
    }

    // 获取动态菜单
    var menus = JSON.parse(sessionStorage.getItem('umenuauths'));
    var list = [];
    if (menus.length > 0) {
      menus.forEach(function (item) {
        if (item.name == '报表') {
          item.children.forEach(function (ite) {
            if (ite.type === 0) {
              list.push(ite);
            }
          });
        }
      });
      this.menusList = list.sort(this.sortBy('priority'));
      if (sessionStorage.getItem('activeReportDownloadName')) {
        this.activeName = sessionStorage.getItem('activeReportDownloadName');
      } else {
        this.activeName = 'tag' + this.menusList[0].id;
      }
    }
  },
  mounted: function mounted() {
    this.tabsCode(); //tab
  },
  methods: {
    getLable: function getLable(val) {
      switch (val) {
        case '日报表':
          return this.$t('report.rbb');
        case '月报表':
          return this.$t('report.ybb');
        case '年报表':
          return this.$t('report.nbb');
        case '设备运行日志':
          return this.$t('report.sbyxrz');
        case '运行诊断':
          return this.$t('report.yxzd');
        case '报警':
          return this.$t('report.bj');
        case '节能量':
          return this.$t('report.jnl');
      }
      return val;
    },
    // 排序
    sortBy: function sortBy(field) {
      //根据传过来的字段进行排序
      return function (x, y) {
        return x[field] - y[field];
      };
    },
    eidtType: function eidtType(type) {
      this.type = type;
      console.log(type);
    },
    handleClick: function handleClick() {
      // 点击切换tab栏发生的事件
      sessionStorage.setItem('activeReportDownloadName', this.activeName);
    },
    handleClickOne: function handleClickOne() {
      var url = this.yuming;
      this.viewVisible = true;
      this.pdfsrc = url;
    },
    //获取当前点击下标
    tabsCode: function tabsCode() {
      var _this = this;
      // 比较结果activeName的值
      // if (this.$route.query.activeName != null) {
      //   this.activeName = this.$route.query.activeName;
      // }
      if (this.$route.query.activeName && this.$route.query.activeName == 'six') {
        this.menusList.forEach(function (it, index) {
          if (it.name == '报警') {
            _this.activeName = 'tag' + it.id;
          }
        });
      }
    }
  }
};